<template>
  <component :is="tag" class="badge" :class="classes"><slot /></component>
</template>

<script>
export default {
  name: "Badge",
  props: {
    tag: {
      type: String,
      default: "span",
    },
    theme: {
      type: String,
      default: "primary",
      validator: (value) => {
        return ["primary", "secondary", "navigation", "product"].includes(
          value
        );
      },
    },
  },
  computed: {
    classes() {
      return {
        "badge--secondary": this.theme === "secondary",
        "badge--navigation": this.theme === "navigation",
        "badge--product": this.theme === "product",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  color: $color-white;
  @include utility-label(10px);
  padding: 8px 12px;
  background-color: rgba($color-black, 0.2);
  border-radius: 4px;
  font-weight: 400;
  line-height: 100%;
  @include respond-above(md) {
    @include utility-label(13px);
  }

  &--secondary {
    color: $color-red;
  }

  &--navigation {
    font-size: 16px;
    color: #357545;
    background-color: transparent;
    @include editorial-body(9px);
    text-transform: uppercase;
    padding: 0 8px;
  }

  &--product {
    display: inline-flex;
    padding: 5px;
    align-items: center;
    border-radius: 2px;
    background: #f2f2f2;
    color: #333;
    font-family: $utility-font-family;
    font-size: 9px;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.5px;
    text-transform: none;
    height: 19px;

    @include respond-above(md) {
      font-size: 11px;
      padding: 5px 10px;
      height: 21px;
    }
  }
}
</style>
